import { Image, Col } from 'antd';
import ImgSrc from 'assets/buy_the_mile_logo.png'

export default function HomePage() {


  return (
    <Col offset={5}  style={{marginTop: 50}}>
      <Image
        preview={false}
        src={ImgSrc}
        width={600}
      />
    </Col>
  );

}

